import React from "react";
import { TStaticDrawFunction } from "../../../Components/Canvas";
import { MeasurementChartPainter } from "./MeasurementChartPainter";
import MeasurementChart from "./MeasurementChart";
import useControlAttribute from "../../../hooks/useControlAttribute";
import { IControl } from "../types";
import useControlMeasurements from "../../../hooks/useControlMeasurements";
import { useTranslation } from "react-i18next";

interface IPVEnergyChartProps {
  control: IControl;
  width: number;
  height: number;
}

const PVEnergyChart = (props: IPVEnergyChartProps) => {
  const { control, width, height } = props;
  const value = useControlAttribute(control, "energy_pv_today");
  const { valuesList } = useControlMeasurements(control, ["energy_pv"]);
  const { t } = useTranslation();

  if (!valuesList) {
    return null;
  }

  const draw: TStaticDrawFunction = (ctx) => {
    const chart = new MeasurementChartPainter(width, height);
    chart.drawBars(ctx, valuesList[0], "#ff6464", " kW");
  };

  return (
    <MeasurementChart
      title={t("Today's PV Energy") + `: ${value} kW`}
      draw={draw}
      width={width}
      height={height}
    />
  );
};

export default PVEnergyChart;
